import React, { useState } from 'react';
import { Conversations } from '@ant-design/x';
import { RedoOutlined } from '@ant-design/icons';
import { Spin, Divider } from 'antd';
import InfiniteScroll from 'react-infinite-scroll-component';
import clsx from 'clsx';
import { useChatbotContext } from '@/hooks/useProviderContext';
import { type XAiConversationsProps } from '@/types/XAiConversations';
import logo from '@/assets/logo.png';
import AddChatIcon from '@/assets/svg/AddChatIcon';
import flashOpen from '@/assets/flash-open.svg?url';
import { SESSION_PAGE_SIZE } from '@/constants';
import { useStyles, GlobalStyle } from './styles';

const XAiConversations: React.FC<XAiConversationsProps> = (props) => {
  const styles = useStyles();
  const { mergedProps } = useChatbotContext(props);
  const {
    isNarrow = false,
    sessionList,
    style,
    onActiveChange,
    onNewChat,
    loadMoreSessions,
    activeKey,
    menu,
  } = mergedProps;

  const [listVisible, setListVisible] = useState(false);
  const [animateDirection, setAnimateDirection] = useState<'in' | 'out' | null>(null);

  const handleSwitchTab = (key: string) => {
    onActiveChange?.(key);
  };

  const handleNewChat = () => {
    onNewChat?.();
  };

  const handleShowList = () => {
    setListVisible(true);
    setAnimateDirection('in');
  };

  const handleCloseList = () => {
    setAnimateDirection('out');
    setTimeout(() => {
      setListVisible(false);
      setAnimateDirection(null);
    }, 300);
  };

  return (
    <div className={styles.conversationsWrapper}>
      <GlobalStyle />
      {/** 顶部操作栏 */}
      {
        !listVisible && (
          <div className={styles.capWrapper}>
            <img alt="logo" src={logo} className={clsx(styles.w(32), styles.h(29))} />
            <div className={styles.capShape}>
              <div className={styles.capIcon}>
                <img src={flashOpen} alt="" onClick={handleShowList} />
              </div>
              <div className={styles.capIcon}>
                <AddChatIcon className={clsx(styles.w(17), styles.text('#343434'))} onClick={handleNewChat} />
              </div>
            </div>
          </div>
        )
      }

      {/* 会话列表 */}
      <div
        // 展开时必须保持 flex 布局，scrollList 才能获得剩余高度并独立滚动。
        style={{ display: listVisible ? 'flex' : 'none' }}
        className={clsx(
          isNarrow ? styles.nWrapper : styles.fWrapper,
          animateDirection === 'in' && styles.slideIn,
          animateDirection === 'out' && styles.slideOut,
        )}
      >
        {/* 固定头部 */}
        <div className={styles.fheaderWrapper}>
          <img alt="logo" src={logo} className={clsx(styles.w(32), styles.h(29))} />
          <div className={styles.capIcon}>
            <img src={flashOpen} alt="" onClick={handleCloseList} />
          </div>
        </div>
        <div className={styles.addChatBtn} onClick={handleNewChat}>
          <AddChatIcon className={clsx(styles.w(17), styles.mr(10))} />
          开启新对话
        </div>
        <div className={styles.tipTitle}>历史对话</div>

        {/* 滚动区域 */}
        <div className={styles.scrollList}>
          <InfiniteScroll
            dataLength={sessionList.length}
            next={loadMoreSessions}
            hasMore={false}
            loader={(
              <div style={{ textAlign: 'center' }}>
                <Spin indicator={<RedoOutlined spin />} size="small" />
              </div>
            )}
            endMessage={sessionList.length === SESSION_PAGE_SIZE && <Divider plain><span className={styles.textColor('#949494')}>只展示前 50 条数据</span></Divider>}
            style={{ overflow: 'hidden', paddingBottom: '5px' }}
          >
            <Conversations
              activeKey={activeKey}
              onActiveChange={(v) => handleSwitchTab(v)}
              items={sessionList}
              menu={menu}
              style={{
                width: 256,
                borderRadius: '6px',
                ...style,
              }}
            />
          </InfiniteScroll>
        </div>
      </div>

      {/* 遮罩层 - 仅在窄屏且列表可见时显示 */}
      {isNarrow && listVisible && (
        <div className={styles.mask} onClick={handleCloseList} />
      )}
    </div>
  );
};

export default XAiConversations;
